import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { minContentH } from "../const";

export const MainSiteLayout = () => (
  <Box display="flex" flexDirection="column" w="100%" maxW="100%" h="100%" minH={minContentH}>
    <Outlet />
  </Box>
);
